const Loader = () => {
  return (
    <div className="loader-div">
      <div className="loadingio-spinner">
        <div className="ldio-s9bvjz66o8">
          <div>
            <div></div>
          </div>
          <div>
            <div></div>
          </div>
          <div>
            <div></div>
          </div>
          <div>
            <div></div>
          </div>
          <div>
            <div></div>
          </div>
          <div>
            <div></div>
          </div>
          <div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Loader;
